import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Map, List } from "immutable";
import {
    Row, Col, Spin, message
} from "antd";
import { Table } from "components";
import "styles/table.css";
import {APPLICANTS_DETAILS_COLUMNS,  ENTITY_DETAILS_COLUMNS } from "../../constants/table-columns";
import PPDocumentReviewTab from "./pp_documents-review";
// import DocumentsJson from "./documents.json";
import { STATE_STATUS } from "../../constants";
import { fetchPaymentProgramActionDetails } from "../../store/actions";
import { PaymentProgramService } from "../../services";
import { getDataFromQueryString } from "../../utils";

class CaseDocumentChecklist extends React.Component {

    state = {
        currentPage: 1,
        checklistIteratedData : Map(),
        checklistFetched : false,
    };

    get getCheclist(){
        //Outer Checklist data
        return this.props.checklistData.filter(_ => _.id === this.props.caseId);
    }

    get caseChecklist(){
        //extra api data
        return Map(this.props.caseCheckListData.getIn([this.props.caseId ,"data" ]));
    }

    get getCurrentActiveTabIndex(){
        return getDataFromQueryString("ordering");
    }

    componentDidUpdate(prevProps){
        if(prevProps.caseCheclistStatus === STATE_STATUS.FETCHING && this.props.checklistStatus === STATE_STATUS.FETCHED && this.props.caseCheclistStatus === STATE_STATUS.FETCHED){
            if((this.getCheclist && this.getCheclist.size) || getDataFromQueryString("onboarding_id") ){
                let allApplicants = this.caseChecklist.getIn(["extra_data","checklist" , "onboarding" , "applicants" , "value"]);
                if(allApplicants){
                    let newArr =  Object.values(this.caseChecklist.getIn(["extra_data","checklist" , "onboarding" , "entity" , "value"]));
                    allApplicants.map(_ => (
                        _.aadhar_back.documents.length && (_.aadhar_back.documents[0].signzy_data= _["aadhar_front"]?.documents.length ? _["aadhar_front"]?.documents[0].signzy_data :{}),
                        _.aadhar_back.documents.length && (_.aadhar_back.documents[0].name_as_on_aadhar = _["aadhar_front"]?.documents[0] ? _["aadhar_front"]?.documents[0].name_as_on_aadhar : ""),
                        _.aadhar_back.documents.length && (_.aadhar_back.documents[0].gender = _["aadhar_front"]?.documents[0] ? _["aadhar_front"]?.documents[0].gender :  ""),
                        _.aadhar_back.documents.length && (_.aadhar_back.documents[0].aadhar = _["aadhar_front"]?.documents[0] ? _["aadhar_front"]?.documents[0].aadhar : ""),
                        _.aadhar_back.documents.length && (_.aadhar_back.documents[0].city = _["aadhar_front"]?.documents[0] ? _["aadhar_front"]?.documents[0].city : ""),
                        _.aadhar_back.documents.length && (_.aadhar_back.documents[0].state = _["aadhar_front"]?.documents[0] ? _["aadhar_front"]?.documents[0].state : ""),
                        _.aadhar_back.front_details = _["aadhar_front"],
                        newArr.push(Object.values(_).map(__ => ({...__ , company_associate_id : _.company_associate_id , applicant_name : _.name.data}))
                        )));
                    let finalIteratedData = new Map({
                        details : Map({
                            documents : this.filterData("documents" , newArr.flat()).map(__ => ({...__ , ...__.documents[0] , company : this.caseChecklist.getIn(["extra_data" , "payer"])})),
                            details : this.filterData("info" , newArr.flat()),
                        }),                    
                    });
                    this.setState({
                        checklistIteratedData : finalIteratedData
                    });
                }
            }
        }
        if(!this.caseChecklist.size && this.props.caseCheclistStatus !== STATE_STATUS.FETCHING && this.props.checklistStatus !== STATE_STATUS.FETCHING && this.props.checklistStatus === STATE_STATUS.FETCHED && !this.state.checklistFetched){
            this.props.fetchPaymentProgramActionDetails(this.props.caseId , getDataFromQueryString("onboarding_id"));
            this.setState({
                checklistFetched : true
            });
        }
    }

    filterData = (type , data) => {
        if(type === "info"){
            return data.filter(_ => _ && _.type === "info");
        }else if(type === "documents"){
            return data.filter(_ => (_ && _.type === "doc" && _.documents.length));
        }
    }


    componentDidMount() {
        if(this.props.caseId &&this.props.checklistStatus === STATE_STATUS.FETCHED){
            this.props.fetchPaymentProgramActionDetails(this.props.caseId, getDataFromQueryString("onboarding_id"));
        }
    }

    handleDocumentUpdate = (type , file ,data ) => {
        const company_id = this.caseChecklist.getIn(["extra_data" , "payer"]);
        const action_detail_id = getDataFromQueryString("onboarding_id");
        const firstApplicantAssociate_id = this.caseChecklist.getIn(["extra_data","checklist" , "onboarding" , "applicants" , "value"]).length && this.caseChecklist.getIn(["extra_data","checklist" , "onboarding" , "applicants" , "value"]).filter(_=> _.associate_key == 1)[0].company_associate_id;
        if(type=== "upload"){
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                message.error("File must smaller than 2MB!");
            }else{
                message.loading("File Uploading");

                PaymentProgramService.uploadDocumentPP(
                    file ,
                    company_id ,
                    data.document_option ,
                    data.document_id ,
                    data.company_associate_id ||firstApplicantAssociate_id,
                    data.associate_key,
                    action_detail_id
                )
                    .then((response) => {
                        console.log(response);
                        message.success("File Uploaded");
                        this.props.fetchPaymentProgramActionDetails(this.props.caseId, getDataFromQueryString("onboarding_id"));
                    })
                    .catch((err) => {
                        console.log(err);
                        message.error("Failed to Upload file");
                    });
            }
        }else if(type === "delete"){
            let payload = {
                document_master_id: data.document_master_id,
                action_detail_id: action_detail_id,
                document_option: data.document_option || undefined,    
                company_document_id: data.company_document_id,
                document_id: data.document_id,
            };
            message.loading("Deleting file please wait...");
            PaymentProgramService.deleteDocumentPP(company_id , payload)
                .then((response) => {
                    console.log(response);
                    message.success("File Deleted Successfully");
                    this.props.fetchPaymentProgramActionDetails(this.props.caseId, getDataFromQueryString("onboarding_id"));
                })
                .catch((err) => {
                    console.log(err);
                    message.error("Failed to Delete file");
                });
        }
    }

    showUploadDeleteFun = () => {
        if((this.props.permissions.size && this.props.permissions.get("page_dbt_document_upload")) && Number(this.getCurrentActiveTabIndex) == 1){
            return true;
        }
        return false;
    }

    getSelectedColumnsShow = () => {
        let gst_certificat_1 = this.state.checklistIteratedData.getIn(["details" , "documents"] ,[]).filter(_ => _.document_option === "gst_certificate_1")[0];
        let columns = ENTITY_DETAILS_COLUMNS(this.handleDocumentUpdate , this.showUploadDeleteFun());
        if(gst_certificat_1 && gst_certificat_1.file.includes("pdf")){
            columns = columns.filter(_ => !["gst_certificate_2" , "gst_certificate_3"].includes(_.key));
        }
        if(this.getCheclist.size && this.getCheclist.getIn([0 , "dealer_constitution"]) === "Proprietorship"){
            columns =  columns.filter(_ => _.key !== "company_pan");
        }
        return columns;
    };

    render() {
        return (
            <Spin spinning={this.props.loading === "FETCHED" ? false : true}>
                <Row style={{ background: "#ffffff", padding: "20px 24px" }}>
                    <Col span={24}>
                        <h4 className={"mb-10"}>Entity Documents</h4>
                        <Table
                            className={"checklist-table"}
                            columns={this.getSelectedColumnsShow()}
                            data={Map({ "entity": this.caseChecklist.size ? this.caseChecklist.getIn(["extra_data","checklist", "onboarding", "entity", "value"]) : {} }).toList()}
                            pagination={false}
                            showHeader={false}
                            showTopSection={false}
                            noRowSelection={true}
                        />
                        <div className="mt-20">
                            <h4>Applicants Documents</h4>
                            <Table
                                className={"checklist-table"}
                                columns={APPLICANTS_DETAILS_COLUMNS(this.handleDocumentUpdate , this.showUploadDeleteFun())}
                                data={List(this.caseChecklist.size ? this.caseChecklist.getIn(["extra_data","checklist", "onboarding", "applicants", "value"]) : List())}
                                pagination={false}
                                showHeader={false}
                                showTopSection={false}
                                noRowSelection={true}
                            />
                        </div>
                        <PPDocumentReviewTab 
                            files={List(this.state.checklistIteratedData.getIn(["details" , "documents"] ,[]))}
                            filesStatus={STATE_STATUS.FETCHED}
                            companyId={this.caseChecklist.getIn(["extra_data","payer"])}
                            action_detail_id={getDataFromQueryString("onboarding_id")}
                            fetchPaymentProgram={this.fetchPaymentProgram}
                            fetchPaymentProgramActionDetails={this.props.fetchPaymentProgramActionDetails.bind(
                                null , 
                                this.props.caseId, 
                                getDataFromQueryString("onboarding_id"))
                            }
                        />
                    </Col>
                </Row>
            </Spin>
        );
    }
}

CaseDocumentChecklist.propTypes = {
    checklistData: PropTypes.array,
    checklistStatus : PropTypes.string,
    loading: PropTypes.bool,
    caseId: PropTypes.number,
    onCancel: PropTypes.func,
    openAsTab: PropTypes.bool,
    caseDetails: PropTypes.object,
    fetchPaymentProgramActionDetails : PropTypes.func,
    caseCheclistStatus : PropTypes.string,
    caseCheckListData : PropTypes.object,
    permissions : PropTypes.object
};

const mapStateToProps = (state, props) => {
    const currentTab = state.paymentProgramDetails.get("current_tab") || "1";
    return {
        checklistData: state.paymentProgramDetails.getIn([currentTab, "data"]) || List(),
        checklistStatus : state.paymentProgramDetails.getIn([currentTab, "status"]) || STATE_STATUS.UNFETCHED,
        caseId: props.caseId,
        loading: state.paymentProgramDetails.getIn([currentTab, "status"]),
        caseCheclistStatus : state.paymentProgramDetails.get("caseCheckListStatus"),
        caseCheckListData : state.paymentProgramDetails.get("caseCheckList"),
        permissions: state.user.get("permissions"),
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchPaymentProgramActionDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CaseDocumentChecklist);